import { useNavigate } from 'react-router-dom'
import Link from '@jetbrains/ring-ui/dist/link/link'

import { Error } from '../Error/Error'

export function UnknownError() {
	const navigate = useNavigate()
	const handleReloadClick = () => {
		navigate(0)
	}
	return (
		<Error
			title={'❌ Oops, something went wrong'}
			content={
				<div>
					Please, <Link onClick={handleReloadClick}>try again</Link>
				</div>
			}
		/>
	)
}
